import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
} from 'react-bootstrap';
import CurrencyInput from 'react-currency-input';
import ImageUploader from 'react-images-upload';
import CreatableSelect from 'react-select/creatable';
import { connect } from 'react-redux';
import { setShowCreateModal } from '../../redux/modules/show';
import { setUpdateUserInfo } from '../../redux/modules/auth';
import productImg from '../../img/producto.svg';
import productImg2 from '../../img/producto2.svg';
import ayudarImg from '../../img/ayudaIcono.png';
import ayudarImg2 from '../../img/ayudaIcono2.png';
import solicitarImg from '../../img/solicitarIcono.svg';
import solicitarImg2 from '../../img/solicitarIcono2.svg';
import { daneCodes } from '../../utils/daneCodes';
import { getImageUrls } from '../../utils/files';
import {
  mainApiUrl,
  apiUrl,
  businessName,
  businessUserType1,
} from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import PaymentTerms from '../Extras/PaymentTerms/PaymentTerms';
import { getTotalAmount, getTotalAmountInfo } from '../../utils/amounts';
import PsePayment from '../PsePayment/PsePayment';
import CardPayment from '../CardPayment/CardPayment';
import DescuentoNomina from '../DescuentoNomina/DescuentoNomina';
import Score from '../Score/Score';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import AddressesComponent from '../ShoppingCart/AddressesComponent';
import './styles/createModal.scss';

const select = (state) => {
  return {
    user: state.auth.user,
    token: state.auth.token,
    userId: state.auth.userId,
    showCreateModal: state.show.showCreateModal,
    createModalTab: state.show.createModalTab,
    hideTabs: state.show.hideTabs,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setShowCreateModal: (show) => dispatch(setShowCreateModal(show)),
    setUpdateUserInfo: (payload) => dispatch(setUpdateUserInfo(payload)),
  };
}

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

function ConnectedCreateModalComponent(props) {
  const { showCreateModal, hideTabs, user } = props;

  const [tab, setTab] = useState(props.createModalTab);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [details, setDetails] = useState('');
  const [photos, setPhotos] = useState([]);
  const [photoFiles, setPhotoFiles] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [created, setCreated] = useState(false);
  const [anonymousRequest, setAnonymousRequest] = useState(true);
  const [otherBenefitName, setOtherBenefitName] = useState('');
  const [otherBenefitDescription, setOtherBenefitDescription] =
    useState('');
  const [showPaymentTerms, setShowPamentTerms] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [productType, setProductType] = useState('PRODUCTO');
  const [productCategory, setProductCategory] = useState('ACCESORIOS');
  const [shipmentCitiesValue, setShipmentCitiesValue] = useState('');
  const [shipmentCities, setShipmentCities] = useState([]);
  const [countryShipment, setCountryShipment] = useState('SI');

  // Payment.
  const [benefitType, setBenefitType] = useState('OTRO');
  const [benefitAmount, setBenefitAmount] = useState('20000');
  const [otherAmount, setOtherAmount] = useState('');
  const [paymentType, setPaymentType] = useState('PSE');
  const [paymentStage, setPaymentStage] = useState(false);
  const [scoreStage, setScoreStage] = useState(false);

  const [benefitRequestHasAmount, setBenefitRequestHasAmount] =
    useState('NO');
  const [benefitRequestAmount, setBenefitRequestAmount] = useState();

  // Variants.
  const [createVariant, setCreateVariant] = useState(false);
  const [variantName, setVariantName] = useState('');
  const [variantDetails, setVariantDetails] = useState('');
  const [variantPrice, setVariantPrice] = useState('');
  const [variants, setVariants] = useState([]);
  const [variantIndexToUpdate, setVariantIndexToUpdate] = useState(-1);
  const [variantHasOtherPrice, setVariantHasOtherPrice] = useState('NO');

  // Delivery.
  const [hasStock, setHasStock] = useState('SI');
  const [stock, setStock] = useState();
  const [hasDelivery, setHasDelivery] = useState('SI');
  const [deliveryDesc, setDeliveryDesc] = useState();
  const [weight, setWeight] = useState();
  const [deliveryInsurance, setDeliveryInsurance] = useState('SI');
  const [width, setWidth] = useState();
  const [length, setLength] = useState();
  const [height, setHeight] = useState();
  const [deliveryAddress, setDeliveryAddress] = useState();
  const [userAddresses, setUserAddresses] = useState([]);
  const [deliveryPrice, setDeliveryPrice] = useState('');

  const [cityState, setCityState] = useState(daneCodes[0].name_depto);
  const [city, setCity] = useState(daneCodes[0].name_city);
  const location = `${city}, ${cityState}`;

  const isUserType1 =
    user && user.nibiBusinessUserType === businessUserType1;
  const amountInfo = getTotalAmountInfo(
    parseInt(benefitAmount !== 'OTRO' ? benefitAmount : otherAmount),
    paymentType
  );
  const hasScore = user && user.nibiBusinessHasScore;

  useEffect(() => {
    getUserAddresses();
  }, [props.userId]);

  useEffect(() => {
    setValidated(false);
    setCityState(daneCodes[0].name_depto);
    setCity(daneCodes[0].name_city);
  }, [tab]);

  useEffect(() => {
    if (created) setVariants([]);
  }, [created]);

  useEffect(() => {
    setTab(props.createModalTab);
  }, [props.createModalTab]);

  useEffect(() => {
    if (benefitType === 'OTRO') {
      setCityState(daneCodes[0].name_depto);
      setCity(daneCodes[0].name_city);
    }
  }, [benefitType]);

  useEffect(() => {
    if (cityState)
      setCity(
        daneCodes.find((item) => item.name_depto === cityState).name_city
      );
  }, [cityState]);

  useEffect(() => {
    if (productType === 'PRODUCTO') setProductCategory('ACCESORIOS');
    else setProductCategory('LOGISTICOS');
  }, [productType]);

  const getUserAddresses = () => {
    fetch(`${mainApiUrl}/addresses/user/${props.userId}`)
      .then((data) => data.json())
      .then((addresses) => {
        setUserAddresses(addresses);
        if (addresses.length > 0) setDeliveryAddress(addresses[0]);
      });
  };

  const handleShipmentCityChange = (value) => {
    setShipmentCities(value);
  };

  const handleShipmentCityInputChange = (value) => {
    setShipmentCitiesValue(value);
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (shipmentCitiesValue) {
          setShipmentCities([
            ...shipmentCities,
            createOption(shipmentCitiesValue),
          ]);
          setShipmentCitiesValue('');
        }

        event.preventDefault();

        break;
      default:
        return;
    }
  };

  const handleCreateVariant = () => {
    if (!variantName)
      return alert('Debes asignar un nombre para la variante.');
    if (
      variantHasOtherPrice === 'SI' &&
      (!variantPrice || variantPrice <= 0)
    )
      return alert('Debes asignar un precio para la variante.');

    const newVariant = {
      name: variantName,
      details: variantDetails,
      otherPrice: variantHasOtherPrice === 'SI',
      price: variantHasOtherPrice === 'SI' ? variantPrice : 0,
    };

    if (variantIndexToUpdate !== -1) {
      const newArr = [...variants];
      newArr.splice(variantIndexToUpdate, 1, newVariant);
      setVariants(newArr);
    } else {
      setVariants(variants.concat(newVariant));
    }

    alert(
      `Variante ${variantIndexToUpdate !== -1 ? 'editada' : 'agregada'}.`
    );

    setVariantName('');
    setVariantDetails('');
    setVariantPrice('');
    setVariantHasOtherPrice('NO');
    setVariantIndexToUpdate(-1);
    setCreateVariant(false);
  };

  const deleteVariant = (item) => {
    setVariants(variants.filter((variant) => variant.name !== item.name));
  };

  const editVariant = (item, index) => {
    setVariantName(item.name);
    setVariantDetails(item.details);
    setVariantHasOtherPrice(item.otherPrice ? 'SI' : 'NO');
    setVariantPrice(item.otherPrice ? item.price : '');
    setVariantIndexToUpdate(index);
    setCreateVariant(true);
  };

  const handleBackVariant = () => {
    setVariantName('');
    setVariantDetails('');
    setVariantPrice('');
    setVariantHasOtherPrice('NO');
    setVariantIndexToUpdate(-1);
    setCreateVariant(false);
  };

  const handleClose = () => {
    props.setShowCreateModal({
      show: false,
      createModalTab: -1,
      hideTabs: false,
    });

    setTab(-1);
    setName('');
    setDescription('');
    setPrice('');
    setDetails('');
    setPhotos([]);
    setPhotoFiles([]);
    setValidated(false);
    setLoading(false);
    setCreated(false);
    setOtherBenefitName('');
    setOtherBenefitDescription('');
    setBenefitType('OTRO');
    setBenefitAmount('20000');
    setOtherAmount('');
    setPaymentType('PSE');
    setCityState(daneCodes[0].name_depto);
    setCity(daneCodes[0].name_city);
    setPaymentStage(false);
    setScoreStage(false);
  };

  const handlePaymentStep = () => {
    if (benefitAmount === 'OTRO' && !otherAmount)
      alert('Ingresa un valor.');
    else setPaymentStage(true);
  };

  const handleScoreStep = () => {
    setScoreStage(true);
  };

  const updateScoreCallback = async () => {
    props.setUpdateUserInfo({ update: true });
    setLoading(true);

    const createProm = await fetch(
      `${apiUrl}/benefitApplications/create`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: props.token,
          userId: props.userId,
          businessName,
          type: 'COUPON',
          category: benefitType,
          benefitAmount:
            benefitRequestHasAmount === 'SI' ? benefitRequestAmount : 0,
          details: otherBenefitDescription,
          anonymousRequest,
        }),
      }
    );

    const createResp = await createProm.json();

    if (createResp.success) setCreated(true);
    else alert(createResp.message || 'Error. Inténtalo nuevamente.1');

    setLoading(false);
  };

  const onDrop = (pictureFiles, pictureDataURLs) => {
    setPhotos(pictureDataURLs);
    setPhotoFiles(pictureFiles);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (tab === 0) {
      if (!name) return alert('Debes asignar un nombre para el producto.');
      if (price <= 0) return alert('El precio debe ser mayor que 0.');
      if (!description)
        return alert('Debes asignar una descripción para el producto.');
      if (
        countryShipment === 'NO' &&
        (!shipmentCities || shipmentCities.length <= 0)
      )
        return alert(
          'Debes agregar por lo menos una ciudad en donde el producto está disponible.'
        );
      if (hasStock === 'SI' && (!stock || stock <= 0))
        return alert('Debes asignar un número de productos disponibles.');
      if (hasDelivery === 'SI') {
        if (!deliveryDesc)
          return alert('Debes asignar una descripción de envío');
        if (!weight || weight <= 0)
          return alert('Debes asignar un peso para el producto.');
        if (!length || length <= 0)
          return alert('Debes asignar un largo para el producto.');
        if (!height || height <= 0)
          return alert('Debes asignar un alto para el producto.');
        if (!width || width <= 0)
          return alert('Debes asignar un ancho para el producto.');
        if (!deliveryAddress)
          alert('Debes elegir una dirección de envío.');
      } else {
        if (deliveryPrice < 0)
          return alert('El precio de envío debe ser mayor o igual a 0.');
      }
    }

    if (tab === 0 || tab === 1) {
      if (photoFiles.length === 0)
        return alert('Debes subir por lo menos una imagen.');
    }

    if (form.checkValidity()) {
      setLoading(true);
      const photosArray = await getImageUrls(photoFiles);
      const { urlArray } = photosArray;

      if (tab === 0 || tab === 1) {

        if (!photosArray.success) {
          alert('Error al crear el producto. Inténtalo nuevamente.');
        } else {

          let createProm;

          if (tab === 0) {
            createProm = await fetch(`${apiUrl}/products/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: props.token,
                userId: props.userId,
                businessName,
                name,
                description,
                price,
                details,
                thumbnail: urlArray[0],
                photos: urlArray,
                variants: variants.map((item, index) => ({
                  ...item,
                  id: index,
                  price: item.otherPrice ? item.price : price,
                })),
                hasStock,
                stock,
                hasDelivery,
                deliveryDesc,
                weight,
                height,
                width,
                length,
                deliveryInsurance,
                deliveryAddress,
                location,
                deliveryPrice,
                productType,
                productCategory,
                countryShipment: countryShipment === 'SI',
                shipmentCities,
              }),
            });
          } else if (tab === 1) {
            createProm = await fetch(`${apiUrl}/benefits/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: props.token,
                userId: props.userId,
                businessName,
                name,
                description,
                details,
                thumbnail: urlArray[0],
                photos: urlArray,
                benefitType: 'CUSTOM',
                location,
              }),
            });
          }

          const createResp = await createProm.json();

          if (createResp.success) setCreated(true);
          else
            alert(createResp.message || 'Error. Inténtalo nuevamente. 2');
        }
      } else if (tab === 2) {
        if (benefitType === 'OTRO') {
          const createProm = await fetch(
            `${apiUrl}/requestedBenefits/create`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: props.token,
                userId: props.userId,
                businessName,
                name: otherBenefitName,
                description: otherBenefitDescription,
                thumbnail: urlArray[0],
                anonymousRequest,
                location,
              }),
            }
          );

          const createResp = await createProm.json();

          if (createResp.success) setCreated(true);
          else
            alert(createResp.message || 'Error. Inténtalo nuevamente. 3');
        } else {
          const createProm = await fetch(
            `${apiUrl}/benefitApplications/create`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: props.token,
                userId: props.userId,
                businessName,
                type: 'COUPON',
                category: benefitType,
                benefitAmount:
                  benefitRequestHasAmount === 'SI'
                    ? benefitRequestAmount
                    : 0,
                details: otherBenefitDescription,
                anonymousRequest,
              }),
            }
          );

          const createResp = await createProm.json();

          if (createResp.success) setCreated(true);
          else
            alert(createResp.message || 'Error. Inténtalo nuevamente. 4');
        }
      }

      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        className='create-modal-component'
        show={showCreateModal}
        onHide={handleClose}
        size='lg'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {created ? (
            <>
              <h1
                className='app-title'
                style={{
                  fontSize: '1.75rem',
                  marginBottom: '25px',
                }}>
                {tab === 0
                  ? 'Producto creado'
                  : tab === 1
                  ? 'Ayuda creada'
                  : 'Solicitud creada'}{' '}
                con éxito
              </h1>
              <Button
                className='app-button'
                onClick={handleClose}>
                Aceptar
              </Button>
            </>
          ) : (
            <>
              <h1 className='app-title'>¿Qué quieres crear?</h1>

              <Row className='justify-content-center create-options'>
                {(!hideTabs || tab === 0) && (
                  <Col md={4}>
                    <div
                      className={`app-nav-button ${
                        tab === 0 ? 'active' : ''
                      }`}
                      onClick={() => setTab(0)}>
                      <img src={tab === 0 ? productImg2 : productImg} />
                      <span>Producto</span>
                    </div>
                  </Col>
                )}
                {isUserType1 && (
                  <>
                    {(!hideTabs || tab === 1) && (
                      <Col md={4}>
                        <div
                          className={`app-nav-button ${
                            tab === 1 ? 'active' : ''
                          }`}
                          onClick={() => setTab(1)}>
                          <img src={tab === 1 ? ayudarImg2 : ayudarImg} />
                          <span>Ayuda</span>
                        </div>
                      </Col>
                    )}
                    {(!hideTabs || tab === 2) && (
                      <Col md={4}>
                        <div
                          className={`app-nav-button ${
                            tab === 2 ? 'active' : ''
                          }`}
                          onClick={() => setTab(2)}>
                          <img
                            src={tab === 2 ? solicitarImg2 : solicitarImg}
                          />
                          <span>Solicitud de ayuda</span>
                        </div>
                      </Col>
                    )}
                  </>
                )}
              </Row>

              {tab !== -1 && <h2 className='app-title'>Formulario</h2>}

              {paymentStage ? (
                <Form.Row>
                  <Col xs={12}>
                    <i
                      className='fas fa-arrow-alt-circle-left back-icon'
                      onClick={() => setPaymentStage(false)}
                    />
                    {paymentType === 'PSE' ? (
                      <PsePayment
                        amount={
                          benefitAmount !== 'OTRO'
                            ? getTotalAmount(
                                parseInt(benefitAmount),
                                'PSE'
                              )
                            : getTotalAmount(parseInt(otherAmount), 'PSE')
                        }
                        paymentType={'BENEFIT_PAYMENT'}
                        benefitCategory={benefitType}
                      />
                    ) : paymentType === 'CARD' ? (
                      <CardPayment
                        amount={
                          benefitAmount !== 'OTRO'
                            ? getTotalAmount(
                                parseInt(benefitAmount),
                                'CARD'
                              )
                            : getTotalAmount(parseInt(otherAmount), 'CARD')
                        }
                        paymentType={'BENEFIT_PAYMENT'}
                        benefitCategory={benefitType}
                        onFinishTransaction={handleClose}
                      />
                    ) : (
                      <DescuentoNomina
                        amount={
                          benefitAmount !== 'OTRO'
                            ? getTotalAmount(
                                parseInt(benefitAmount),
                                'DESCUENTO_NOMINA'
                              )
                            : getTotalAmount(
                                parseInt(otherAmount),
                                'DESCUENTO_NOMINA'
                              )
                        }
                        paymentType={'BENEFIT_PAYMENT'}
                        benefitCategory={benefitType}
                        onFinishTransaction={handleClose}
                      />
                    )}
                  </Col>
                </Form.Row>
              ) : scoreStage ? (
                loading ? (
                  <Form.Row>
                    <Col xs={12}>
                      <AppSpinner />
                    </Col>
                  </Form.Row>
                ) : (
                  <Form.Row>
                    <Col xs={12}>
                      <Score successCallback={updateScoreCallback} />
                    </Col>
                  </Form.Row>
                )
              ) : (
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}>
                  {tab === 0 ? (
                    showPaymentTerms ? (
                      <>
                        <i
                          className='fas fa-arrow-alt-circle-left'
                          onClick={() => setShowPamentTerms(false)}
                        />
                        <PaymentTerms />
                      </>
                    ) : createVariant ? (
                      <>
                        <Form.Row>
                          <i
                            className='fas fa-arrow-alt-circle-left'
                            onClick={handleBackVariant}
                          />
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Nombre de la variante
                            </Form.Label>
                            <Form.Control
                              type='text'
                              placeholder='Ej: Blanco, talla S'
                              value={variantName}
                              onChange={(event) =>
                                setVariantName(event.target.value)
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Detalles (Opcional)
                            </Form.Label>
                            <Form.Control
                              type='text'
                              placeholder='Detalles adicionales de esta variante'
                              value={variantDetails}
                              onChange={(event) =>
                                setVariantDetails(event.target.value)
                              }
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              ¿Esta variante tiene un precio diferente?
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={variantHasOtherPrice}
                              onChange={(event) =>
                                setVariantHasOtherPrice(event.target.value)
                              }>
                              <option value='NO'>No</option>
                              <option value='SI'>Si</option>
                            </Form.Control>
                          </Form.Group>
                          {variantHasOtherPrice === 'SI' && (
                            <Form.Group
                              as={Col}
                              md={6}>
                              <Form.Label className='app-label'>
                                Precio de esta variante
                              </Form.Label>
                              <CurrencyInput
                                className='form-control'
                                prefix='COP '
                                thousandSeparator='.'
                                precision='0'
                                value={variantPrice}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue
                                ) => setVariantPrice(floatvalue)}
                                required
                              />
                            </Form.Group>
                          )}
                          <Col xs={12}>
                            <Button
                              className='app-button'
                              onClick={handleCreateVariant}>
                              {variantIndexToUpdate !== -1
                                ? 'Editar'
                                : 'Crear'}{' '}
                              variante
                            </Button>
                          </Col>
                        </Form.Row>
                      </>
                    ) : (
                      <Form.Row>
                        <Col xs={12}>
                          <Alert variant='info'>
                            Acá puedes subir productos o servicios hechos
                            por ti para vender entre la comunidad. Puedes
                            subir hasta 5 productos. Ten en cuenta las
                            tarifas que aplican al vender productos a
                            través de la plataforma, para ver estas tarifas
                            haz click{' '}
                            <span
                              className='terms-anchor'
                              onClick={() => setShowPamentTerms(true)}>
                              aquí
                            </span>
                            . Recuerda que no se aceptan productos que
                            compitan con la oferta de CEMEX y sus negocios
                            asociados, así como productos usados, ilegales,
                            violentos o sexuales.
                          </Alert>
                        </Col>
                        <Form.Group
                          as={Col}
                          md={8}>
                          <Form.Label className='app-label'>
                            Nombre del producto
                          </Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Nombre del producto'
                            value={name}
                            onChange={(event) =>
                              setName(event.target.value)
                            }
                            required
                          />
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md={4}>
                          <Form.Label className='app-label'>
                            Precio
                          </Form.Label>
                          <CurrencyInput
                            className='form-control'
                            prefix='COP '
                            thousandSeparator='.'
                            precision='0'
                            value={price}
                            onChangeEvent={(
                              event,
                              maskedvalue,
                              floatvalue
                            ) => setPrice(floatvalue)}
                            required
                          />
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md={6}>
                          <Form.Label className='app-label'>
                            Departamento
                          </Form.Label>
                          <Form.Control
                            as='select'
                            value={cityState}
                            onChange={(e) => setCityState(e.target.value)}
                            required>
                            <option hidden></option>
                            {Object.keys(
                              groupBy(daneCodes, 'name_depto')
                            ).map((state, i) => (
                              <option
                                key={i}
                                value={state}>
                                {state}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md={6}>
                          <Form.Label className='app-label'>
                            Ciudad
                          </Form.Label>
                          <Form.Control
                            as='select'
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            required>
                            <option hidden></option>
                            {Object.values(
                              groupBy(
                                daneCodes.filter(
                                  (entry) => entry.name_depto === cityState
                                ),
                                'name_city'
                              )
                            ).map((city, i) => (
                              <option
                                key={i}
                                value={city[0].name_city}>
                                {city[0].name_city}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md={6}>
                          <Form.Label className='app-label'>
                            ¿El producto puede ser enviado a cualquier
                            lugar del país o solamente a ciudades
                            específicas?
                          </Form.Label>
                          <Form.Control
                            as='select'
                            value={countryShipment}
                            onChange={(event) =>
                              setCountryShipment(event.target.value)
                            }>
                            <option value='SI'>Todo el país</option>
                            <option value='NO'>
                              Ciudades específicas
                            </option>
                          </Form.Control>
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md={12}>
                          {countryShipment === 'NO' && (
                            <>
                              <Form.Label className='app-label'>
                                Escribe las ciudades en donde tu producto
                                está disponible
                              </Form.Label>
                              <CreatableSelect
                                components={{
                                  DropdownIndicator: null,
                                }}
                                inputValue={shipmentCitiesValue}
                                menuIsOpen={false}
                                onChange={handleShipmentCityChange}
                                onInputChange={
                                  handleShipmentCityInputChange
                                }
                                onKeyDown={handleKeyDown}
                                placeholder='Escribe una ciudad y coloca enter...'
                                value={shipmentCities}
                                isMulti
                                isClearable
                              />
                            </>
                          )}
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md={6}>
                          <Form.Label className='app-label'>
                            Tipo del producto
                          </Form.Label>
                          <Form.Control
                            as='select'
                            value={productType}
                            onChange={(event) =>
                              setProductType(event.target.value)
                            }>
                            <option value='PRODUCTO'>Producto</option>
                            <option value='SERVICIO'>Servicio</option>
                          </Form.Control>
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md={6}>
                          <Form.Label className='app-label'>
                            Categoría del producto
                          </Form.Label>
                          <Form.Control
                            as='select'
                            value={productCategory}
                            onChange={(event) =>
                              setProductCategory(event.target.value)
                            }>
                            {productType === 'PRODUCTO' ? (
                              <>
                                <option value='ACCESORIOS'>
                                  Accesorios
                                </option>
                                <option value='ROPA'>Ropa</option>
                                <option value='COMESTIBLES_ALIMENTOS'>
                                  Comestibles y alimentos
                                </option>
                                <option value='ARTESANIAS'>
                                  Artesanías
                                </option>
                                <option value='PUBLICIDAD'>
                                  Publicidad
                                </option>
                                <option value='OTROS'>Otros</option>
                              </>
                            ) : (
                              <>
                                <option value='LOGISTICOS'>
                                  Servicios logísticos
                                </option>
                                <option value='HOGAR'>
                                  Servicios para el hogar
                                </option>
                                <option value='BELLEZA'>
                                  Servicios de belleza
                                </option>
                                <option value='OTROS'>Otros</option>
                              </>
                            )}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md={12}>
                          <Form.Label className='app-label'>
                            Descripción
                          </Form.Label>
                          <Form.Control
                            type='text'
                            as='textarea'
                            rows='3'
                            placeholder='Describe el producto'
                            value={description}
                            onChange={(event) =>
                              setDescription(event.target.value)
                            }
                            required
                          />
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md={12}>
                          <Form.Label className='app-label'>
                            Subir fotos del producto
                          </Form.Label>
                          <ImageUploader
                            className='multImageInput'
                            withIcon={false}
                            withPreview={true}
                            fileContainerStyle={{
                              borderRadius: '5px',
                              borderStyle: 'solid',
                              borderColor: 'lightgray',
                              borderWidth: 'thin',
                            }}
                            buttonText='Escoge una o varias imágenes'
                            label='Tamaño máximo por imagen: 5mb, formatos: jpg, gif, png'
                            onChange={onDrop}
                            imgExtension={[
                              '.jpeg',
                              '.jpg',
                              '.gif',
                              '.png',
                              '.gif',
                            ]}
                            maxFileSize={5242880}
                            fileSizeError='Archivo demasiado grande. Máximo 5mb.'
                            fileTypeError='Extension del archivo no soportado.'
                            defaultImages={photos}
                          />
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md={12}>
                          <Form.Label className='app-label'>
                            Detalles (opcional)
                          </Form.Label>
                          <Form.Control
                            type='text'
                            as='textarea'
                            rows='3'
                            placeholder='Detalles adicionales del producto'
                            value={details}
                            onChange={(event) =>
                              setDetails(event.target.value)
                            }
                          />
                        </Form.Group>

                        <Col xs={12}>
                          <Form.Label className='app-label'>
                            Variantes
                          </Form.Label>
                          <Form.Text
                            className='text-muted'
                            style={{
                              marginBottom: '15px',
                            }}>
                            Las variantes sirven para configurar las
                            distintas opciones o categorías que tiene tu
                            producto. Por ejemplo, si tu producto tiene
                            diferentes tallas, colores o tamaños puedes
                            crear variantes para cada una de estas
                            opciones.
                          </Form.Text>
                          {variants.map((item, index) => (
                            <div
                              key={index}
                              className='variant-item'>
                              <span className='variant-name'>
                                {item.name} - $
                                {formatMoney(item.price || price)}
                              </span>
                              <span className='icons'>
                                <i
                                  className='fas fa-edit'
                                  onClick={() => editVariant(item, index)}
                                />
                                <i
                                  className='fas fa-trash-alt delete-icon'
                                  onClick={() => deleteVariant(item)}
                                />
                              </span>
                              <hr />
                            </div>
                          ))}
                          <Button
                            className='app-button'
                            onClick={() => setCreateVariant(true)}>
                            Agregar variante
                          </Button>
                          <hr />
                        </Col>
                        <Form.Group
                          as={Col}
                          md={6}>
                          <Form.Label className='app-label'>
                            ¿Este producto cuenta con inventario limitado?
                          </Form.Label>
                          <Form.Control
                            as='select'
                            value={hasStock}
                            onChange={(event) =>
                              setHasStock(event.target.value)
                            }>
                            <option value='SI'>Si</option>
                            <option value='NO'>No</option>
                          </Form.Control>
                        </Form.Group>
                        {hasStock === 'SI' ? (
                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              Número de productos disponibles
                            </Form.Label>
                            <Form.Control
                              type='number'
                              placeholder='Inventario'
                              value={stock}
                              onChange={(event) =>
                                setStock(event.target.value)
                              }
                              required
                            />
                          </Form.Group>
                        ) : (
                          <Col md={6}></Col>
                        )}
                        <Col xs={12}>
                          <hr />
                        </Col>

                        <Form.Group
                          as={Col}
                          md={12}>
                          <Form.Label className='app-label'>
                            ¿Deseas realizar tus envíos a través de nibi?
                          </Form.Label>
                          <Form.Text className='text-muted'>
                            Al seleccionar esta opción, cada vez que
                            realices una venta enviaremos una{' '}
                            <strong>guía de envío</strong> a tu correo
                            electrónico, la cual debes imprimir y llevar
                            junto con el producto a la oficina más cercana
                            de la empresa de logística que te indiquemos.
                            En caso de que no selecciones esta opción,
                            deberás hacerte cargo de la logística de
                            entrega de tu producto. Además, ten en cuenta
                            que el <strong>costo de envío</strong> se le
                            carga al usuario al momento de la compra.
                          </Form.Text>
                          <Form.Control
                            as='select'
                            value={hasDelivery}
                            onChange={(event) =>
                              setHasDelivery(event.target.value)
                            }>
                            <option value='SI'>Si</option>
                            <option value='NO'>No</option>
                          </Form.Control>
                        </Form.Group>
                        {hasDelivery === 'SI' ? (
                          <>
                            <Form.Group
                              as={Col}
                              md={4}>
                              <Form.Label className='app-label'>
                                ¿Qué envías?
                              </Form.Label>
                              <Form.Control
                                type='text'
                                placeholder='Ropa, documentos, accesorios, etc'
                                value={deliveryDesc}
                                onChange={(event) =>
                                  setDeliveryDesc(event.target.value)
                                }
                                required
                              />
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md={4}>
                              <Form.Label className='app-label'>
                                Peso (Kg)
                              </Form.Label>
                              <Form.Control
                                type='number'
                                placeholder='Peso'
                                value={weight}
                                onChange={(event) =>
                                  setWeight(event.target.value)
                                }
                                required
                              />
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md={4}>
                              <Form.Label className='app-label'>
                                ¿Seguro de envío?
                              </Form.Label>
                              <Form.Control
                                as='select'
                                value={deliveryInsurance}
                                onChange={(event) =>
                                  setDeliveryInsurance(event.target.value)
                                }>
                                <option value='SI'>Si</option>
                                <option value='NO'>No</option>
                              </Form.Control>
                              <Form.Text className='text-muted'>
                                Ten en cuenta que el seguro de envío podría
                                aumentar el precio del envío.
                              </Form.Text>
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md={4}>
                              <Form.Label className='app-label'>
                                Largo (Cm)
                              </Form.Label>
                              <Form.Control
                                type='number'
                                placeholder='Largo'
                                value={length}
                                onChange={(event) =>
                                  setLength(event.target.value)
                                }
                                required
                              />
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md={4}>
                              <Form.Label className='app-label'>
                                Ancho (Cm)
                              </Form.Label>
                              <Form.Control
                                type='number'
                                placeholder='Ancho'
                                value={width}
                                onChange={(event) =>
                                  setWidth(event.target.value)
                                }
                                required
                              />
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md={4}>
                              <Form.Label className='app-label'>
                                Alto (Cm)
                              </Form.Label>
                              <Form.Control
                                type='number'
                                placeholder='Alto'
                                value={height}
                                onChange={(event) =>
                                  setHeight(event.target.value)
                                }
                                required
                              />
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md={6}>
                              <Form.Label className='app-label'>
                                Dirección de donde se envía el producto
                              </Form.Label>
                              <Form.Control
                                as='select'
                                onChange={(event) =>
                                  setDeliveryAddress(
                                    JSON.parse(event.target.value)
                                  )
                                }
                                required>
                                {userAddresses.map((address) => (
                                  <option
                                    key={address._id}
                                    value={JSON.stringify(address)}>
                                    {address.short}{' '}
                                    {`(${address.street} , ${address.city})`}
                                  </option>
                                ))}
                              </Form.Control>
                              <div
                                style={{
                                  marginTop: '10px',
                                }}>
                                <Button
                                  variant='outline-success'
                                  onClick={() =>
                                    setShowAddressModal(true)
                                  }>
                                  Agregar nueva dirección
                                </Button>
                              </div>
                            </Form.Group>
                          </>
                        ) : (
                          <>
                            <Form.Group
                              as={Col}
                              md={6}>
                              <Form.Label className='app-label'>
                                Precio de envío
                              </Form.Label>
                              <Form.Text className='text-muted'>
                                Ingresa el precio estimado del envío de tu
                                producto. (este precio se sumará al precio
                                final del producto).
                              </Form.Text>
                              <CurrencyInput
                                className='form-control'
                                prefix='COP '
                                thousandSeparator='.'
                                precision='0'
                                value={deliveryPrice}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue
                                ) => setDeliveryPrice(floatvalue)}
                                required
                              />
                            </Form.Group>
                          </>
                        )}
                        <Col xs={12}>
                          <hr />
                        </Col>

                        <Button
                          type='submit'
                          className='app-button'
                          disabled={loading}>
                          {loading ? (
                            <Spinner
                              animation='border'
                              variant='warning'
                              size='sm'
                            />
                          ) : (
                            'Crear producto'
                          )}
                        </Button>
                      </Form.Row>
                    )
                  ) : tab === 1 ? (
                    <Form.Row>
                      {benefitType === 'OTRO' ? (
                        <>
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Título de la ayuda
                            </Form.Label>
                            <Form.Control
                              type='text'
                              placeholder='Título de la ayuda'
                              value={name}
                              onChange={(event) =>
                                setName(event.target.value)
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              Departamento
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={cityState}
                              onChange={(e) =>
                                setCityState(e.target.value)
                              }
                              required>
                              <option hidden></option>
                              {Object.keys(
                                groupBy(daneCodes, 'name_depto')
                              ).map((state, i) => (
                                <option
                                  key={i}
                                  value={state}>
                                  {state}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              Ciudad
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required>
                              <option hidden></option>
                              {Object.values(
                                groupBy(
                                  daneCodes.filter(
                                    (entry) =>
                                      entry.name_depto === cityState
                                  ),
                                  'name_city'
                                )
                              ).map((city, i) => (
                                <option
                                  key={i}
                                  value={city[0].name_city}>
                                  {city[0].name_city}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Descripción de la ayuda
                            </Form.Label>
                            <Form.Control
                              type='text'
                              as='textarea'
                              rows='3'
                              placeholder='Describe la ayuda'
                              value={description}
                              onChange={(event) =>
                                setDescription(event.target.value)
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Detalles (opcional)
                            </Form.Label>
                            <Form.Control
                              type='text'
                              as='textarea'
                              rows='3'
                              placeholder='Detalles adicionales de la ayuda'
                              value={details}
                              onChange={(event) =>
                                setDetails(event.target.value)
                              }
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Subir fotos de la ayuda
                            </Form.Label>
                            <ImageUploader
                              className='multImageInput'
                              withIcon={false}
                              withPreview={true}
                              fileContainerStyle={{
                                borderRadius: '5px',
                                borderStyle: 'solid',
                                borderColor: 'lightgray',
                                borderWidth: 'thin',
                              }}
                              buttonText='Escoge una o varias imágenes'
                              label='Tamaño máximo por imagen: 5mb, formatos: jpg, gif, png'
                              onChange={onDrop}
                              imgExtension={[
                                '.jpeg',
                                '.jpg',
                                '.gif',
                                '.png',
                                '.gif',
                              ]}
                              maxFileSize={5242880}
                              fileSizeError='Archivo demasiado grande. Máximo 5mb.'
                              fileTypeError='Extension del archivo no soportado.'
                              defaultImages={photos}
                            />
                          </Form.Group>
                          <Button
                            type='submit'
                            className='app-button'
                            disabled={loading}>
                            {loading ? (
                              <Spinner
                                animation='border'
                                variant='warning'
                                size='sm'
                              />
                            ) : (
                              'Crear'
                            )}
                          </Button>
                        </>
                      ) : (
                        <>
                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              Valor del bono
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={benefitAmount}
                              onChange={(event) =>
                                setBenefitAmount(event.target.value)
                              }>
                              <option value='20000'>20.000</option>
                              <option value='50000'>50.000</option>
                              <option value='100000'>100.000</option>
                              <option value='200000'>200.000</option>
                              <option value='OTRO'>Otro</option>
                            </Form.Control>
                          </Form.Group>
                          {benefitAmount === 'OTRO' && (
                            <Form.Group
                              as={Col}
                              md={6}>
                              <Form.Label className='app-label'>
                                Valor
                              </Form.Label>
                              <Form.Control
                                type='number'
                                placeholder='Valor'
                                value={otherAmount}
                                onChange={(event) =>
                                  setOtherAmount(event.target.value)
                                }
                                required
                              />
                            </Form.Group>
                          )}
                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              Método de pago
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={paymentType}
                              onChange={(event) =>
                                setPaymentType(event.target.value)
                              }>
                              <option value='PSE'>PSE</option>
                              <option value='CARD'>
                                Tarjeta de crédito
                              </option>
                              <option value='DESCUENTO_NOMINA'>
                                Descuento de nómina
                              </option>
                            </Form.Control>
                          </Form.Group>
                          <Col xs={12}>
                            <Alert variant='info'>
                              A continuación te mostramos los valores
                              asociados a este pago. Ten en cuenta que el{' '}
                              <strong>monto final</strong> a pagar depende
                              del método de pago que selecciones:
                              <ul>
                                <li>
                                  <strong>
                                    {paymentType === 'PSE'
                                      ? 'PSE:'
                                      : paymentType === 'CARD'
                                      ? 'Tarjeta de crédito:'
                                      : 'Descuento de nómina:'}
                                  </strong>
                                  <ul>
                                    <li>
                                      Valor del bono:{' '}
                                      {formatMoney(
                                        benefitAmount !== 'OTRO'
                                          ? benefitAmount
                                          : otherAmount
                                      )}
                                    </li>
                                    <li>
                                      Costos financieros y de tecnología:{' '}
                                      {formatMoney(
                                        amountInfo.totalDiscounted
                                      )}
                                    </li>
                                    <li>
                                      TOTAL:{' '}
                                      {formatMoney(amountInfo.total)}
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </Alert>
                          </Col>
                          <Col xs={12}>
                            <Button
                              className='app-button'
                              onClick={handlePaymentStep}>
                              Continuar
                            </Button>
                          </Col>
                        </>
                      )}
                    </Form.Row>
                  ) : tab === 2 ? (
                    <Form.Row>
                      <Col xs={12}>
                        <Alert variant='info'>
                          Acá puedes crear una solicitud de ayuda
                          particular que no hayas podido encontrar en el
                          muro de la solidaridad. Esta solicitud será
                          aprobada y te notificaremos cuando alguien de la
                          comunidad ofrezca ayudarte. Recuerda que puedes
                          hacer la solicitud de forma anónima o pública.
                        </Alert>
                      </Col>
                      <Form.Group
                        as={Col}
                        md={12}>
                        <Form.Label className='app-label'>
                          Escoge una categoría
                        </Form.Label>
                        <Form.Control
                          as='select'
                          value={benefitType}
                          onChange={(event) =>
                            setBenefitType(event.target.value)
                          }
                          required>
                          <option value='MERCADO'>
                            Mercado y alimentos
                          </option>
                          <option value='MEDICINAS'>
                            Farmacia y medicamentos
                          </option>
                          <option value='EDUCACION'>Educación</option>
                          <option value='OTRO'>Otro</option>
                        </Form.Control>
                      </Form.Group>

                      {benefitType !== 'OTRO' && (
                        <>
                          <Form.Group
                            as={Col}
                            md={6}>
                            <Form.Label className='app-label'>
                              ¿Deseas solicitar esta ayuda por un monto en
                              específico?
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={benefitRequestHasAmount}
                              onChange={(event) =>
                                setBenefitRequestHasAmount(
                                  event.target.value
                                )
                              }
                              required>
                              <option value='NO'>No</option>
                              <option value='SI'>Si</option>
                            </Form.Control>
                          </Form.Group>

                          {benefitRequestHasAmount === 'SI' && (
                            <Form.Group
                              as={Col}
                              md={6}>
                              <Form.Label className='app-label'>
                                Monto solicitado
                              </Form.Label>
                              <CurrencyInput
                                className='form-control'
                                prefix='COP '
                                thousandSeparator='.'
                                precision='0'
                                value={benefitRequestAmount}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue
                                ) => setBenefitRequestAmount(floatvalue)}
                                required
                              />
                            </Form.Group>
                          )}
                        </>
                      )}

                      {benefitType === 'OTRO' && (
                        <>
                          <Col xs={12}>
                            <Alert variant='info'>
                              Ten en cuenta que esta opción es para
                              solicitar ayudas de primera necesidad.
                            </Alert>
                          </Col>
                          <Form.Group
                            as={Col}
                            md={12}>
                            <Form.Label className='app-label'>
                              Nombre
                            </Form.Label>
                            <Form.Control
                              type='text'
                              placeholder='Nombre de la ayuda'
                              value={otherBenefitName}
                              onChange={(event) =>
                                setOtherBenefitName(event.target.value)
                              }
                              required
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md={6}
                            controlId='formGridState'>
                            <Form.Label className='app-label'>
                              Departamento
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={cityState}
                              onChange={(e) =>
                                setCityState(e.target.value)
                              }
                              required>
                              <option hidden></option>
                              {Object.keys(
                                groupBy(daneCodes, 'name_depto')
                              ).map((state, i) => (
                                <option
                                  key={i}
                                  value={state}>
                                  {state}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md={6}
                            controlId='formGridCity'>
                            <Form.Label className='app-label'>
                              Ciudad
                            </Form.Label>
                            <Form.Control
                              as='select'
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required>
                              <option hidden></option>
                              {Object.values(
                                groupBy(
                                  daneCodes.filter(
                                    (entry) =>
                                      entry.name_depto === cityState
                                  ),
                                  'name_city'
                                )
                              ).map((city, i) => (
                                <option
                                  key={i}
                                  value={city[0].name_city}>
                                  {city[0].name_city}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </>
                      )}
                      <Form.Group
                        as={Col}
                        md={12}>
                        <Form.Label className='app-label'>
                          Descripción{' '}
                          {benefitType !== 'OTRO' && '(Opcional)'}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          as='textarea'
                          rows='3'
                          placeholder={
                            benefitType === 'OTRO'
                              ? 'Describe la ayuda'
                              : 'Deja una descripción de por qué necesitas esta ayuda'
                          }
                          value={otherBenefitDescription}
                          onChange={(event) =>
                            setOtherBenefitDescription(event.target.value)
                          }
                          required={benefitType === 'OTRO'}
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md={12}>
                        <Form.Label className='app-label'>
                          Subir fotos de la ayuda
                        </Form.Label>
                        <ImageUploader
                          className='multImageInput'
                          withIcon={false}
                          withPreview={true}
                          fileContainerStyle={{
                            borderRadius: '5px',
                            borderStyle: 'solid',
                            borderColor: 'lightgray',
                            borderWidth: 'thin',
                          }}
                          buttonText='Escoge una o varias imágenes'
                          label='Tamaño máximo por imagen: 5mb, formatos: jpg, gif, png'
                          onChange={onDrop}
                          imgExtension={[
                            '.jpeg',
                            '.jpg',
                            '.gif',
                            '.png',
                            '.gif',
                          ]}
                          maxFileSize={5242880}
                          fileSizeError='Archivo demasiado grande. Máximo 5mb.'
                          fileTypeError='Extension del archivo no soportado.'
                          defaultImages={photos}
                        />
                      </Form.Group>
                      <Col xs={12}>
                        <div className='custom-control custom-checkbox'>
                          <input
                            checked={anonymousRequest}
                            onChange={() =>
                              setAnonymousRequest(!anonymousRequest)
                            }
                            type='checkbox'
                            className='custom-control-input'
                            id='anonymCb'
                          />
                          <label
                            className='custom-control-label'
                            htmlFor='anonymCb'>
                            Quiero crear esta solicitud de forma anónima.
                          </label>
                        </div>
                      </Col>
                      <br />
                      <br />

                      <Col xs={12}>
                        {benefitType === 'OTRO' || hasScore ? (
                          <Button
                            type='submit'
                            className='app-button'
                            disabled={loading}>
                            {loading ? (
                              <Spinner
                                animation='border'
                                variant='warning'
                                size='sm'
                              />
                            ) : (
                              'Solicitar'
                            )}
                          </Button>
                        ) : (
                          <Button
                            className='app-button'
                            onClick={handleScoreStep}>
                            Solicitar
                          </Button>
                        )}
                      </Col>
                    </Form.Row>
                  ) : null}
                </Form>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        size='lg'
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Agrega una dirección de envío</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddressesComponent
            userId={props.userId}
            refreshAddresses={() => getUserAddresses()}
            closeModal={() => setShowAddressModal(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

const CreateModalComponent = connect(
  select,
  mapDispatchToProps
)(ConnectedCreateModalComponent);

export default CreateModalComponent;
